import type { OfflineRewardWire } from '@kenocyber/shared';
import { formatDecimal } from './format';

/**
 * What the player earned while away.
 *
 * States the accounted time and both amounts, and says plainly that offline
 * farm never produces items - a promise the domain enforces and the wire
 * contract repeats (`itemsGranted: false`).
 */
export function OfflineRewardDialog({
  reward,
  onClose,
}: {
  readonly reward: OfflineRewardWire;
  readonly onClose: () => void;
}) {
  const minutes = Math.floor(reward.creditedMs / 60_000);
  const hours = Math.floor(minutes / 60);
  const elapsed = hours > 0 ? `${hours} h ${minutes % 60} min` : `${minutes} min`;

  return (
    <div className="offline-backdrop" data-testid="offline-reward">
      <div className="offline-panel">
        <h2 className="offline-title">Farm offline</h2>
        <p className="offline-elapsed" data-testid="offline-elapsed">
          Tempo contabilizado: <strong>{elapsed}</strong>
        </p>
        <dl className="offline-rewards">
          <div className="offline-row">
            <dt>XP recebido</dt>
            {/* Decimal strings straight from the server: no cap, no rounding. */}
            <dd data-testid="offline-xp">{formatDecimal(reward.xpGained)}</dd>
          </div>
          <div className="offline-row">
            <dt>Gold recebido</dt>
            <dd data-testid="offline-gold">{formatDecimal(reward.goldGained)}</dd>
          </div>
          {BigInt(reward.levelsGained) > 0n ? (
            <div className="offline-row">
              <dt>Níveis ganhos</dt>
              <dd data-testid="offline-levels">{formatDecimal(reward.levelsGained)}</dd>
            </div>
          ) : null}
        </dl>
        <p className="offline-note">Farm offline não gera itens.</p>
        <button
          type="button"
          className="offline-close"
          data-testid="offline-close"
          onClick={onClose}
        >
          Continuar
        </button>
      </div>
    </div>
  );
}
